import SkipLink from '@/components/SkipLink'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import {useGrubhubUserAddress} from '@/lib/food-grubhub/store'
import HeadTags from '@/lib/head/HeadTags'
import skipTargetProps from '@/utils/a11y/skipTargetProps'

import FoodGrubhubDefaultContent from './components/FoodGrubhubDefaultContent/FoodGrubhubDefaultContent'
import FoodGrubhubSearchResult from './components/FoodGrubhubSearchResult/FoodGrubhubSearchResult'
import style from './FoodGrubhub.module.scss'

const FoodGrubhub = () => {
  const [storageUserLocation] = useGrubhubUserAddress()

  const hasUserLocation =
    storageUserLocation.latitude !== null &&
    storageUserLocation.longitude !== null &&
    storageUserLocation.address !== null &&
    storageUserLocation.address !== ''

  return (
    <div>
      <HeadTags title='Food & Grocery' />
      <SkipLink title='Skip to main content' to='#main-content' />
      <Navbar variant='dark' />
      <main {...skipTargetProps('main-content')} className={style.Page}>
        {!hasUserLocation && <FoodGrubhubDefaultContent />}
        {hasUserLocation && (
          <Suspense fallback={null}>
            <FoodGrubhubSearchResult />
          </Suspense>
        )}
      </main>

      <Suspense>
        <Footer />
      </Suspense>
    </div>
  )
}

export default FoodGrubhub
